import { ODER_BY_TYPE, ORDER_BY } from '@app/constants/Common';
import {
    DVTJCUVSearchCddJobParentTabs, DVTJCUVSearchCddJobSendEmailBriefUVTabs,
    DVTJCUVSearchCddJobSetReceiverListTabs
} from "@pages/dvtjcuv/common/SearchCddJobTabs";
import UpdateDVTJCUVPipelineModal from "@pages/dvtjcuv/edit/UpdateDVTJCUVPipelineModal";
import DVTJCUVPipelineTableList, { DVTJCUVPipelineListMode } from "@pages/dvtjcuv/list/DVTJCUVPipelineTableList";
import DVTJCUVSearchCddJobBriefEmailCandidateList from "@pages/dvtjcuv/rundvtjcuv/DVTJCUVSearchCddJobBriefEmailCandidateList";
import DVTJCUVEmpCareBriefUVTabContent from "@pages/dvtjcuv/rundvtjcuv/search/searchcddjob/DVTJCUVEmpCareBriefUVTabContent";
import DVTJCUVHaveJobTabContent from "@pages/dvtjcuv/rundvtjcuv/search/searchcddjob/DVTJCUVHaveJobTabContent";
import DVTJCUVReceiversAutoReleasedTabContent from "@pages/dvtjcuv/rundvtjcuv/search/searchcddjob/DVTJCUVReceiversAutoReleasedTabContent";
import DVTJCUVReceiversManuallyReleasedTabContent from "@pages/dvtjcuv/rundvtjcuv/search/searchcddjob/DVTJCUVReceiversManuallyReleasedTabContent";
import DVTJCUVReceiversSentTabContent from "@pages/dvtjcuv/rundvtjcuv/search/searchcddjob/DVTJCUVReceiversSentTabContent";
import { requestGetDVTJCUVPipeLineList } from "@pages/dvtjcuv/service/DVTJCUVPipelineService";
import React, { useEffect, useState } from 'react';


const DVTJCUVSearchCddJobContent = (props) => {
    const [parentOfTab, setParentOfTab] = useState({});
    const [currentTab, setCurrentTab] = useState({});
    const [childTabList, setChildTabList] = useState([]);
    const [pipelineList, setPipelineList] = useState([]);
    const [dataInfo, setDataInfo] = useState({});
    const [mailTabData, setMailTabData] = useState({});

    const [showUpdatePipelineModal, setShowUpdatePipelineModal] = useState(false);
    const [selectPipeline, setSelectPipeline] = useState({});
    const [sortColumns, setSortColumns] = useState({
        created_date_time: ORDER_BY.DESC_UPDATE_DATE
    });

    const {cddId, data, parentTab, onChangeRootTab} = props

    const fetchPipeLines = async (pTab, subTab, sorts) => {
        const params = {
            search_conditions: {
                cdd_id: cddId,
                parent_tab: pTab?.id,
                sub_tab: subTab?.id,
                unlimited: true
            },
            sort_columns: sorts
        }

        const res = await requestGetDVTJCUVPipeLineList(params);
        const resContent = res.content
        setPipelineList(resContent.pipelines)
    }

    // Function set tab content, return sub tab
    const setTabContents = (pTab) => {
        setParentOfTab(pTab)
        if (pTab && pTab.childTabs) {
            const childTabs = Object.values(pTab.childTabs)
            setCurrentTab(childTabs[0])
            setChildTabList(childTabs)
            return childTabs[0]
        }
        return {}
    }

    useEffect(() => {
        console.log("parentTab:" + JSON.stringify(parentTab))
        if (parentTab) {
            const subTab = setTabContents(parentTab)

            // Chỉ những tab ko có childs mới get piplines, các tabs có childs đã set riêng trong createTabContent rồi.
            if (childTabList.length === 0) {
                fetchPipeLines(parentTab, subTab)
            }
        }
        if (data) {
            setDataInfo(data)
        }

    }, [data, parentTab]);

    const onTabClicked = async (tab) => {
        setCurrentTab({...tab});
        if (!tab.childTabs || Object.keys(tab.childTabs).length === 0) {
            await fetchPipeLines(parentOfTab, tab, sortColumns)
        }
    };

    const activeTab = (tab) => {
        if (currentTab.id === tab.id) {
            return 'active'
        }
        return ''
    }

    const onShowEditPipeline = (item, fromReferee) => {
        item.fromReferee = !!fromReferee
        setSelectPipeline({...item})
        setShowUpdatePipelineModal(true)
    }

    const createTabContentWaitingSendByMonthWeek = (subTab) => {
        let passLimitTitle = 'Pass HM gửi tháng'
        let notPassLimitTitle = 'Hết HM gửi tháng'
        if (subTab.id === DVTJCUVSearchCddJobSendEmailBriefUVTabs.WAITING_SEND_BY_WEEK_TAB.id) {
            passLimitTitle = 'Pass HM gửi tuần'
            notPassLimitTitle = 'Hết HM gửi tuần'
        }
        return <>
            <div className='card card-default'>
                <div className='card-header'>
                    <h3 className="card-title text-bold">{passLimitTitle}</h3>
                </div>
                <div className='card-body p-0'>
                    <DVTJCUVSearchCddJobBriefEmailCandidateList
                        cddId={cddId}
                        parentTab={parentTab}
                        subTab={subTab}
                        isPassLimitWeekOrMonth
                    />
                </div>
            </div>
            <div className='card card-default'>
                <div className='card-header'>
                    <h3 className="card-title text-bold">{notPassLimitTitle}</h3>
                </div>
                <div className='card-body p-0'>
                <DVTJCUVSearchCddJobBriefEmailCandidateList
                        cddId={cddId}
                        parentTab={parentTab} subTab={subTab}
                        isPassLimitWeekOrMonth={false}
                    />
                </div>
            </div>
        </>
    }

    const createTabContent = (subTab) => {
        if (parentTab.id === DVTJCUVSearchCddJobParentTabs.SEND_EMAIL_BRIEF_UV_TAB.id) {
            if (subTab.id === DVTJCUVSearchCddJobSendEmailBriefUVTabs.WAITING_SEND_BY_WEEK_TAB.id
                || subTab.id === DVTJCUVSearchCddJobSendEmailBriefUVTabs.WAITING_SEND_BY_MONTH_TAB.id) {
                return createTabContentWaitingSendByMonthWeek(subTab)
            }

            return <DVTJCUVSearchCddJobBriefEmailCandidateList
                cddId={cddId}
                parentTab={parentTab} subTab={subTab}
            />
        }

        if (subTab.id === DVTJCUVSearchCddJobSetReceiverListTabs.RECEIVERS_AUTO_RELEASED_TAB.id) {
            return <DVTJCUVReceiversAutoReleasedTabContent
                        cddId={cddId}
                        onChangeRootTab={onChangeRootTab}
                        // parentTab={DVTJCUVSearchCddJobSetReceiverListTabs.RECEIVERS_AUTO_RELEASED_TAB}

                    />
        }

        if (subTab.id === DVTJCUVSearchCddJobSetReceiverListTabs.RECEIVERS_MANUALLY_RELEASED_TAB.id) {
            return <DVTJCUVReceiversManuallyReleasedTabContent
                        cddId={cddId}
                        onChangeRootTab={onChangeRootTab}
                        parentTab={DVTJCUVSearchCddJobSetReceiverListTabs.RECEIVERS_MANUALLY_RELEASED_TAB}
                    />
        }

        if (parentTab.id === DVTJCUVSearchCddJobParentTabs.HAVE_JOB_TAB.id) {
            return <DVTJCUVHaveJobTabContent
                cddId={cddId}
                parentTab={DVTJCUVSearchCddJobParentTabs.HAVE_JOB_TAB}
                subTab={subTab}
            />
        }

        return <DVTJCUVReceiversSentTabContent
            cddId={cddId}
        />
    }

    const onSort = async (columnKey) => {
        let tempSortColumns = sortColumns
        if (tempSortColumns[columnKey] && tempSortColumns[columnKey] === ODER_BY_TYPE.ASC) {
            tempSortColumns[columnKey] = ODER_BY_TYPE.DESC
        } else {
            tempSortColumns = {}
            tempSortColumns[columnKey] = ODER_BY_TYPE.ASC
        }

        setSortColumns({...tempSortColumns})

        await fetchPipeLines(parentOfTab, currentTab, tempSortColumns)
    }

    const createTabContentOfTabHasNoChild = () => {
        if (parentTab.id === DVTJCUVSearchCddJobParentTabs.EMP_CARE_BRIEF_UV_TAB.id) {
            return <DVTJCUVEmpCareBriefUVTabContent
                cddId={cddId}
                parentTab={DVTJCUVSearchCddJobParentTabs.EMP_CARE_BRIEF_UV_TAB}
            />
        }

        return <DVTJCUVPipelineTableList
            pipeLines={pipelineList}
            onSort={onSort}
            sortColumn={sortColumns}
            mode={DVTJCUVPipelineListMode.RUN_DVTJCUV_SEARCH_JOB_CDD}
            parentTabId={parentTab.id}
            onEditItem={(selectItem, fromReferee) => onShowEditPipeline(selectItem, fromReferee)}
        />
    }

    return (
        <>
            {
                childTabList.length === 0 ? (
                        createTabContentOfTabHasNoChild()
                )
                :
                <>
                    <ul className='nav nav-tabs' role='tablist'>
                        {childTabList.map(tab => (
                            <li className='nav-item' key={`saved-list-tab-item-${tab.id}`}>
                                <a className={`nav-link ${activeTab(tab)}`} data-toggle='tab' href={`#${tab.id}`}
                                   onClick={() => onTabClicked(tab)}>{tab.title}
                                    ({mailTabData[tab.id] ? mailTabData[tab.id] : 0})
                                </a>
                            </li>
                        ))}
                    </ul>
                    <div className='tab-content'>
                        {childTabList.map((tab, index) => {
                            if (currentTab.id === tab.id) {
                                return <div id={tab.id} className={`tab-pane ${activeTab(tab)}`}
                                            style={{height: '83vh', overflow: 'auto'}}
                                            key={`run-dvtjcuv-sub-tab-content-${parentTab.id}-${tab.id}`}>
                                    {createTabContent(currentTab)}
                                </div>
                            }
                            return "";
                        })}
                    </div>
                </>
            }

            {showUpdatePipelineModal &&
                <UpdateDVTJCUVPipelineModal isShow={showUpdatePipelineModal}
                                            pipeLineInfo={selectPipeline}
                                            onClose={(reload) => setShowUpdatePipelineModal(false)}
                />
            }
        </>
    )
}

export default DVTJCUVSearchCddJobContent;
